import { render, staticRenderFns } from "./general-info-view-tab.vue?vue&type=template&id=63a2bb07&scoped=true"
import script from "./general-info-view-tab.vue?vue&type=script&lang=js"
export * from "./general-info-view-tab.vue?vue&type=script&lang=js"
import style0 from "./general-info-view-tab.vue?vue&type=style&index=0&id=63a2bb07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a2bb07",
  null
  
)

export default component.exports